import React from 'react';
import { Link2, Twitter, Facebook, Linkedin, MessageCircle, Share } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { useSharePost } from '../hooks/useSharePost';

interface SharePostMenuProps {
  postId: string;
  postContent?: string;
  children?: React.ReactNode;
}

export function SharePostMenu({ postId, postContent, children }: SharePostMenuProps) {
  const {
    copyPostLink,
    shareToTwitter,
    shareToFacebook,
    shareToLinkedIn,
    shareViaSms,
    shareNative,
    canNativeShare,
  } = useSharePost();

  const previewText = postContent
    ? postContent.length > 100
      ? postContent.substring(0, 97) + '...'
      : postContent
    : undefined;

  const handleNativeShare = () => {
    shareNative(postId, previewText);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {children || (
          <Button variant="ghost" size="sm" className="flex items-center gap-2 text-muted-foreground">
            <Share className="h-5 w-5" />
            <span className="text-sm">Share</span>
          </Button>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={() => copyPostLink(postId)}>
          <Link2 className="h-4 w-4 mr-2" />
          Copy Link
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => shareToTwitter(postId, previewText)}>
          <Twitter className="h-4 w-4 mr-2" />
          Share to X
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => shareToFacebook(postId)}>
          <Facebook className="h-4 w-4 mr-2" />
          Share to Facebook
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => shareToLinkedIn(postId)}>
          <Linkedin className="h-4 w-4 mr-2" />
          Share to LinkedIn
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => shareViaSms(postId)}>
          <MessageCircle className="h-4 w-4 mr-2" />
          Share via SMS
        </DropdownMenuItem>
        {canNativeShare() && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleNativeShare}>
              <Share className="h-4 w-4 mr-2" />
              More Options...
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
